"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenLinksContainer = exports.StyledDownload = exports.LinkWrapper = exports.ShownLinksContainer = exports.Title = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const Download_1 = __importDefault(require("../icon/svgs/Download"));
const PREFIX = "ExpandableLinksTextCard";
exports.classes = {
    link: `${PREFIX}-link`,
    hiddenLinksContainer: `${PREFIX}-hiddenLinksContainer`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    borderBottom: `1px solid ${theme.colours.storm}`,
    padding: "30px 0",
    [`.${exports.classes.link}`]: {
        display: "block",
        fontSize: "18px",
        marginBottom: "16px"
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    marginBottom: theme.spacing(3)
}));
exports.ShownLinksContainer = (0, styles_1.styled)("div")({
    [`.${exports.classes.link}:last-child`]: {
        marginBottom: 0
    }
});
exports.LinkWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    marginBottom: "14px",
    "&:last-child": {
        marginBottom: 0
    }
});
exports.StyledDownload = (0, styles_1.styled)(Download_1.default)(({ theme }) => ({
    color: theme.colours.inter,
    width: "24px",
    height: "24px",
    marginRight: "8px"
}));
exports.HiddenLinksContainer = (0, styles_1.styled)("div")({
    [`.${exports.classes.link}:first-of-type`]: {
        marginTop: "16px"
    },
    [`.${exports.classes.link}:last-of-type`]: {
        marginBottom: 0
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2V4cGFuZGFibGUtbGlua3MtdGV4dC1jYXJkL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpREFBOEM7QUFDOUMsK0RBQXVDO0FBQ3ZDLHFFQUE2QztBQUU3QyxNQUFNLE1BQU0sR0FBRyx5QkFBeUIsQ0FBQztBQUU1QixRQUFBLE9BQU8sR0FBRztJQUNyQixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDdEIsb0JBQW9CLEVBQUUsR0FBRyxNQUFNLHVCQUF1QjtDQUN2RCxDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELFlBQVksRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFO0lBQ2hELE9BQU8sRUFBRSxRQUFRO0lBQ2pCLENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNwQixPQUFPLEVBQUUsT0FBTztRQUNoQixRQUFRLEVBQUUsTUFBTTtRQUNoQixZQUFZLEVBQUUsTUFBTTtLQUNyQjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxLQUFLLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN0RCxZQUFZLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7Q0FDL0IsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLG1CQUFtQixHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQy9DLENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxhQUFhLENBQUMsRUFBRTtRQUMvQixZQUFZLEVBQUUsQ0FBQztLQUNoQjtDQUNGLENBQUMsQ0FBQztBQUVVLFFBQUEsV0FBVyxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3ZDLE9BQU8sRUFBRSxNQUFNO0lBQ2YsWUFBWSxFQUFFLE1BQU07SUFDcEIsY0FBYyxFQUFFO1FBQ2QsWUFBWSxFQUFFLENBQUM7S0FDaEI7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLGNBQWMsR0FBRyxJQUFBLGVBQU0sRUFBQyxrQkFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzdELEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsS0FBSyxFQUFFLE1BQU07SUFDYixNQUFNLEVBQUUsTUFBTTtJQUNkLFdBQVcsRUFBRSxLQUFLO0NBQ25CLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxvQkFBb0IsR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNoRCxDQUFDLElBQUksZUFBTyxDQUFDLElBQUksZ0JBQWdCLENBQUMsRUFBRTtRQUNsQyxTQUFTLEVBQUUsTUFBTTtLQUNsQjtJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxlQUFlLENBQUMsRUFBRTtRQUNqQyxZQUFZLEVBQUUsQ0FBQztLQUNoQjtDQUNGLENBQUMsQ0FBQyJ9